<script>
import sourceMixin from '../../components/mixins/v-mixin-source.vue';
import controller from '../../scripts/controller/controller';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			catalog: null
		};
	},

	created() {
		controller.events.on('update-model-source', dataType => {
			this.updateModelSource(dataType);
		});
	},

	methods: {
		dataSet(data) {
			if (data.type === 'basket') {
				this.$store.commit('basket/set', data);
			}
			if (data.type === 'favorite') {
				this.$store.commit('favorite/set', data);
			}
			if (data.type === 'user') {
				this.$store.commit('user/set', data);
			}
			if (data.type === 'compare') {
				this.$store.commit('compare/set', data);
			}
			if (data.type === 'location') {
				this.$store.commit('location/set', data);
			}
			if (data.type === 'delivery') {
				this.$store.commit('delivery/set', data);
			}
			if (data.type === 'appWidget') {
				this.$store.commit('appWidget/set', data);
			}
			if (data.type === 'breadcrumbs') {
				this.$store.commit('breadcrumbs/set', data);
			}
			this.catalog = data;
		},

		updateModelSource(dataType) {
			if (dataType && dataType === this.catalog.type) {
				this.dataLoad({
					url: this.catalog.remote,
					delay: true,
					data: {
						action: 'update'
					}
				});
			}
		}
	},

	render() {
		return '';
	}
};
</script>